import request from './request';

/**
 *  获取数据
 */
export function loadData(category, interval) {
    return request('/stat/driving/vehicle-lossing', {
        method: 'GET',
        params: {
            category,
            interval,
        },
    });
}
